import PieChartGraph from "@/Graphs/PieChartGraph";
import useRoutesHandler from "@/Hooks/useRouteHandler";
import ChartContainer from "@/UI/Containers/ChartContainer";
import { StopIcon } from "@heroicons/react/16/solid";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useGetAllEnquiriesServices } from "@repo/api-services/admin";
import { ButtonBase } from "@repo/ui/index.tsx";
import { stringUtility } from "@repo/utilities/string.utility.ts";
function ClaimsPieChart() {
  const { navigate } = useRoutesHandler();
  const {
    services: { allEnquiriesServices },
  } = useGetAllEnquiriesServices({});

  // const totalLeads = allEnquiriesServices?.data?.meta?.total;

  const dataSet = [
    {
      Total_GHC: 12,
      Total_GPA: 18,
      GHC_GPA: 18,
      TOTAL_GHI: 20,
      TOTAL_GCI: 15,
      GCI_GPA: 17,
    },
  ];

  const dataMap = [
    { key: "Total_GHC", colorClass: "fill-blue-500" },
    { key: "Total_GPA", colorClass: "fill-green-500" },
    { key: "GHC_GPA", colorClass: "fill-orange-500" },
    { key: "TOTAL_GHI", colorClass: "fill-purple-500" },
    { key: "TOTAL_GCI", colorClass: "fill-yellow-500" },
    { key: "GCI_GPA", colorClass: "fill-slate-500" },
  ];

  if (allEnquiriesServices?.isLoading)
    return (
      <div className="flex-1 w-full h-full rounded-lg bg-extraLightGray animate-pulse" />
    );

  const TooltipComponent = ({ payload }: { payload?: Record<any, any>[] }) => {
    return (
      <div className="flex flex-col gap-2 bg-white p-2 rounded-md border  border-extraLightGray z-10">
        {payload?.map((payloadUnit) => {
          return (
            <div
              key={payloadUnit?.dataKey}
              className="flex items-center gap-2 text-sm font-semibold"
            >
              <StopIcon className={`size-4 ${payloadUnit.className}`} />
              <p className="capitalize">
                {stringUtility.removeCharAddSpace(payloadUnit.name, "_")}:
              </p>
              <p>{payloadUnit.value}L</p>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <ChartContainer
        showZoom={false}
        topRightActionComp={
          <ButtonBase
            buttonType="tertiary"
            text="See details"
            icon={<ChevronRightIcon className="size-4" />}
            className="text-body"
            onClick={() => {
              navigate("/leads");
            }}
          />
        }
        headingComp={<h3 className="font-semibold">Claims Settled</h3>}
        className={`h-full w-2/5 flex flex-col gap-2 relative`}
      >
        <div className=" flex flex-col items-center mt-5 text-body absolute top-1/2  left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <p className="text-[2.8rem] font-semibold">{"1Cr"}</p>
          <p className="text-sm font-semibold">Total</p>
        </div>
        <PieChartGraph
          dataSet={dataSet}
          dataMap={dataMap}
          toolTipComp={<TooltipComponent />}
        />
      </ChartContainer>
    </>
  );
}

export default ClaimsPieChart;
